import React, { useState } from 'react';
import { GenPage, SegmentControl } from '../components/Common/GenPage';
import { useT } from '../utils/i18n';

export const VoiceOver = () => {
  const t = useT();
  const [duration, setDuration] = useState('60s');

  return (
    <GenPage
      title={t('page.voiceOver.title')}
      contentType="voiceOver"
      description={t('page.voiceOver.desc')}
      outputLabel={t('page.voiceOver.output')}
      extraOptions={
        <div className="flex items-center gap-1.5">
          <span className="text-xs text-gray-500 font-medium whitespace-nowrap">{t('label.duration')}</span>
          <SegmentControl
            options={['30s', '45s', '60s', '90s', '2min']}
            value={duration}
            onChange={setDuration}
          />
        </div>
      }
      extraInstructions={`Target VO duration: ${duration}`}
    />
  );
};
